/**
 * Script para controle da barra de compartilhamento social.
 */
document.addEventListener('DOMContentLoaded', function() {
    initSocialShareBar();
});

/**
 * Inicializa a barra de compartilhamento flutuante 
 */
function initSocialShareBar() {
    const shareBar = document.querySelector('.gh-social-share-container');
    if (!shareBar) return;
    
    const article = document.querySelector('.gh-article');
    const articleHeader = document.querySelector('.gh-article-header');
    const articleContent = document.querySelector('.gh-content');
    const articleComments = document.querySelector('.gh-comments');
    
    // Configurações para efeito de peek
    let peekTimeout;
    let lastScrollY = 0;
    let scrollDirection = 'down';
    
    // Sempre exibe a barra de compartilhamento
    function updateShareBarVisibility() {
        // Sempre adiciona a classe is-visible para mostrar a barra
        shareBar.classList.add('is-visible');
        // Garantir visibilidade independente do CSS
        shareBar.style.display = 'block';
        shareBar.style.opacity = '1';
    }
    
    // Verifica a posição da barra de compartilhamento durante o scroll
    function updateShareBarPosition() {
        if (!article || !articleHeader || !articleContent) return;
        
        const scrollY = window.scrollY || window.pageYOffset;
        
        // Determina a direção do scroll
        if (scrollY > lastScrollY) {
            scrollDirection = 'down';
        } else if (scrollY < lastScrollY) {
            scrollDirection = 'up';
        }
        lastScrollY = scrollY;
        
        const articleTop = article.getBoundingClientRect().top + scrollY;
        const articleHeaderHeight = articleHeader.offsetHeight;
        const articleBottom = articleContent.offsetHeight + articleContent.offsetTop;
        const commentsBottom = articleComments ? articleComments.offsetHeight + articleComments.offsetTop : articleBottom;
        
        // Define a região na qual a barra deve ficar visível
        const startShowingPosition = articleTop + articleHeaderHeight;
        const stopShowingPosition = commentsBottom;
        
        if (scrollY > startShowingPosition && scrollY < stopShowingPosition) {
            shareBar.classList.add('is-fixed');
            shareBar.style.opacity = '1'; // Sempre visível
            
            // Efeito de peek depois de parar de rolar
            clearTimeout(peekTimeout);
            
            if (scrollDirection === 'down') {
                shareBar.classList.add('is-peeking');
                peekTimeout = setTimeout(() => {
                    shareBar.classList.remove('is-peeking');
                }, 2000);
            }
        } else {
            shareBar.classList.remove('is-fixed');
            shareBar.style.opacity = '1'; // Sempre visível mesmo fora da área de conteúdo
        }
    }
    
    // Inicializa a visibilidade e posição da barra
    updateShareBarVisibility();
    updateShareBarPosition();
    
    // Adiciona event listeners para atualizar durante scroll e redimensionamento
    window.addEventListener('scroll', updateShareBarPosition);
    window.addEventListener('resize', function() {
        updateShareBarVisibility();
        updateShareBarPosition();
    });
    
    // Hover mostra a barra completamente
    shareBar.addEventListener('mouseenter', function() {
        shareBar.classList.add('is-active');
    });
    
    shareBar.addEventListener('mouseleave', function() {
        shareBar.classList.remove('is-active');
    });
} 